// src/components/settings/shared/SystemSettingsElements.tsx

import { Box, Typography, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';
import { colors } from '../../../theme/themeTypes';

export const SettingsBlock = styled(Box)({
  width: '100%',
  marginTop: '1.5rem',
});

export const SettingsCard = styled(Paper)(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.02)' : '#ffffff',
  border: `1px solid ${theme.palette.mode === 'dark' ? colors.secondary.dark : colors.primary.light}`,
  borderRadius: '8px',
}));

export const SectionLabel = styled(Typography)(({ theme }) => ({
  fontSize: '1.1rem',
  fontWeight: 700,
  textTransform: 'uppercase',
  letterSpacing: '0.5px',
  color:
    theme.palette.mode === 'dark' ? colors.primary.light : colors.primary.main,
  marginBottom: '0.75rem',
}));

export const SettingRow = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: '1rem',
});

export const SettingLabel = styled(Typography)({
  fontSize: '1.4rem',
  fontWeight: 600,
});

export const SettingDescription = styled(Typography)(({ theme }) => ({
  fontSize: '1.2rem',
  color: theme.palette.text.secondary,
  marginTop: '2px',
}));

export const SectionDivider = styled(Box)(({ theme }) => ({
  height: '1px',
  backgroundColor:
    theme.palette.mode === 'dark'
      ? 'rgba(255, 255, 255, 0.08)'
      : colors.primary.light,
  margin: '0 1.5rem',
}));

export const Section = styled(Box)({
  padding: '1.25rem 1.5rem',
});

export const RetentionGrid = styled(Box)({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(130px, 1fr))',
  gap: '0.75rem',
  marginTop: '0.75rem',
});

export const RetentionStat = styled(Box)(({ theme }) => ({
  padding: '0.75rem 1rem',
  borderRadius: '6px',
  backgroundColor:
    theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.03)' : '#f5f8ff',
  border: `1px solid ${theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.06)' : colors.primary.light}`,
}));

export const StatLabel = styled(Typography)(({ theme }) => ({
  fontSize: '0.95rem',
  color: theme.palette.text.secondary,
  textTransform: 'uppercase',
  letterSpacing: '0.5px',
}));

export const StatValue = styled(Typography)({
  fontSize: '1.2rem',
  fontWeight: 600,
  marginTop: '2px',
});

export const formatDateTime = (iso: string | null): string => {
  if (!iso) return 'Never';
  return new Date(iso).toLocaleString('en-ZA', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};
